import { createRouter, createWebHistory } from "vue-router";
import Home from "@/views/Home";
import About from "@/views/About";
import Subprogram from "@/views/Subprogram";
import Team from "@/views/Team";
import Projects from "@/views/Projects";
import Facility from "@/views/Facility";
import NotFound from "@/views/NotFound";
import Bulletins from "@/views/Bulletins";
import Monitoring from "@/views/Monitoring";
import Articles from "@/views/Publications/Articles";
import Reports from "@/views/Publications/Reports";
import Thesis from "@/views/Publications/Thesis";
//import Publications from "@/views/Publications.vue";
import ENFEN from "@/views/Migration/ENFEN";
import ResearcherProfile from "@/views/ResearcherProfile";
//
import MonitoreoInterno from "@/components/facility/microfisica/Monitoreo/MonitoreoInterno.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/acerca-de",
    name: "Acerca de",
    component: About,
  },
  {
    path: "/subprogramas/:subprogram",
    name: "Subprogram",
    component: Subprogram,
  },
  {
    path: "/equipo",
    name: "Nuestro Equipo",
    component: Team,
  },
  {
    path: "/proyectos/manglares",
    name: "Manglares",
    component: () => import("../views/Projects/Manglares.vue"),
  },
  {
    path: "/proyectos/proclim",
    name: "PROCLIM",
    component: () => import("../views/Projects/Proclim.vue"),
  },
  {
    path: "/proyectos/incagro",
    name: "INCAGRO",
    component: () => import("../views/Projects/Incagro.vue"),
  },
  {
    path: "/proyectos/vocals",
    name: "VOCALS",
    component: () => import("../views/Projects/Vocals.vue"),
  },
  {
    path: "/proyectos/maremex",
    name: "MAREMEX",
    component: () => import("../views/Projects/Maremex.vue"),
  },
  {
    path: "/proyectos/andesplus",
    name: "ANDESPLUS",
    component: () => import("../views/Projects/Andesplus.vue"),
  },
  {
    path: "/proyectos/influencia-ecosistemas-andinos",
    name: "Influence",
    component: () => import("../views/Projects/InfluenciaEcosistemas.vue"),
  },
  {
    path: "/proyectos/SCOR",
    name: "SCOR",
    component: () => import("../views/Projects/Scor.vue"),
  },
  {
    path: "/proyectos/:type",
    name: "Projects",
    component: Projects,
  },
  {
    path: "/facilidad/:facility/:section?",
    name: "Facilities",
    component: Facility,
  },
  {
    path: "/facilidad/:facility/:section?/:subsection?",
    name: "Facilidades",
    component: Facility,
  },

  {
    path: "/facilidad/microfisica/monitoreo/monitoreo-interno",
    name: "Monitoreo interno",
    component: MonitoreoInterno,
  },
  {
    path: "/monitoreo-pronostico/:monitoring?",
    name: "Monitoreo y Pronóstico",
    component: Monitoring,
  },
  {
    path: "/monitoreo-pronostico/:monitoring?/:section?/:subsection?",
    name: "Monitoreo y Pronóstico",
    component: Monitoring,
  },

  {
    path: "/publicaciones/boletines/:subject?",
    name: "Boletines",
    component: Bulletins,
  },
  {
    path: "/publicaciones/articulos/:subtype?",
    name: "Articulos",
    component: Articles,
  },
  {
    path: "/publicaciones/informes/:subtype?",
    name: "Informes",
    component: Reports,
  },
  {
    path: "/publicaciones/academicos/:subtype?",
    name: "Tesis",
    component: Thesis,
  },
  {
    path: "/enfen/:section?",
    name: "ENFEN",
    component: ENFEN,
  },
  {
    path: "/profile/:researcher",
    name: "Perfil de Investigador",
    component: ResearcherProfile,
  },
  {
    path: "/:catchAll(.*)",
    name: "404",
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return {
        savedPosition,
        behavior: "smooth",
      };
    } else {
      return { behavior: "smooth", top: 0 };
    }
  },
});

export default router;
